import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { ProxyErrorStateMatcher } from '@input/proxy-error-state-matcher';
import { parseDec } from '@util/utils';
import { Subscription } from 'rxjs';

let inputId = 1;

export interface InputFocusOut {
  ref: InputComponent,
  event: Event
}

@Component({
  selector: 'app-input',
  templateUrl: './input.component.html',
})
export class InputComponent implements OnDestroy, OnInit {

  cls = '';

  _lastEmitValue: any;

  dlId = '';

  @Input() label = '';

  @Input() placeholder = '';

  @Input() name = '';

  @Input() suffix = '';

  @Input() readonly = false;

  isPasswordField = false;

  public _type = 'text';

  @Input() set type(t: string) {
    this._type = t;

    this.isPasswordField = (t === 'password');
  }

  changePasswordInput() {
    this._type = this._type === 'password' ? 'text' : 'password';
  }

  @Input() datalist: string[] = [];

  public _maxLength = 0;
  @Input() set maxlength(maxlength: number | string | null) {
    let val: any = maxlength;
    if (!Number.isFinite(maxlength) && typeof maxlength === 'string') {
      val = parseDec(maxlength);
    }

    if (Number.isFinite(val)) {
      this._maxLength = val;
    } else {
      console.error('Failed to set maxlength', maxlength);
    }
  }

  public _disabled = false;
  @Input() set disabled(disabled: boolean) {
    this._disabled = disabled;
  }

  public _required = false;
  @Input() set required(req: boolean) {
    this._required = req;
  }

  public _showThousandSeparator = false;
  @Input('thousand-sep') set showThousandSeparator(sep: boolean) {
    this._showThousandSeparator = sep;
    this.updateView();
  }

  public _value = '';
  @Input() set value(value: any) {
    if (value !== this._value && this._lastEmitValue !== value) {
      this._value = value;
      this.updateView();
    }
  }

  @Output() valueChange = new EventEmitter();

  @Output() afterValueChange = new EventEmitter();

  @Output() focusout = new EventEmitter<InputFocusOut>();

  inputControl = new UntypedFormControl('');

  inputSub!: Subscription;

  errorSM = new ProxyErrorStateMatcher();

  /*
  private _elem!: ElementRef;
  @ViewChild('ic') set ic(elem: ElementRef) {
    this._elem = elem;
  }
  */

  constructor() {
    inputId++;
    this.dlId = 'dl_' + inputId;
  }

  ngOnInit(): void {
    this.inputSub = this.inputControl.valueChanges.subscribe((value: any) => {
      this.onChange(value);
    });
  }

  ngOnDestroy(): void {
    this.inputSub.unsubscribe();
  }

  onChange($event: any) {
    this._lastEmitValue = $event;
    this._value = $event;
    this.valueChange.emit($event);
    this.afterValueChange.emit();
    this.updateView();
  }

  error = '';

  setError(error: string) {
    this.error = error;
    this.errorSM.hasError = !!error;
    //console.log('INE:', error, this.errorSM.hasError);
  }

  hasMaxLengthError = false;

  updateView() {
    if (this._maxLength > 0 && this._value) {
      this.hasMaxLengthError = this._value.length > this._maxLength;
    } else {
      this.hasMaxLengthError = false;
    }

    this.errorSM.hasError = this.errorSM.hasError || this.hasMaxLengthError;

    /*
    if (this._showThousandSeparator && false) {
      const val = removeAllFromString(this._value, '.');
      let num = parseDec(val);
      MyLog.log('VIEW:', val, num);

      if (!isNaN(num) && num >= 1000) {
        const parts: any[] = [];

        while (num >= 1) {
          const v = (num % 1000).toFixed(0);
          parts.unshift(v);
          num /= 1000;
        }
        const val = parts.join('.');
        MyLog.log('SET:', val, parts);

        this.inputControl.setValue(val, {
          emitEvent: false,
          emitModelToViewChange: false,
          emitViewToModelChange: true
        });

        if (this._elem?.nativeElement) {
          this._elem.nativeElement.value = val;
        }
        return;
      }
    }
    */
    this.inputControl.setValue(this._value, {
      emitEvent: false
    });
  }

  highlightError() {
    this.cls = 'error-highlight';
    setTimeout(() => {
      this.cls = '';
    }, 800);
  }

  focout($event: Event) {
    this.focusout.emit({ ref: this, event: $event });
  }
  /*
  refreshView() {
    this.inputControl.updateValueAndValidity({
      onlySelf:true,
      emitEvent:false
    });
  }
  */
}
